import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "dialog-custom__header mb-4" }
const _hoisted_2 = { class: "dialog-custom__title" }
const _hoisted_3 = { class: "dialog-custom__content form-custom" }
const _hoisted_4 = { style: {"width":"450px","height":"600px"} }
const _hoisted_5 = {
  key: 0,
  class: "p-field"
}
const _hoisted_6 = {
  key: 0,
  class: "p-field"
}
const _hoisted_7 = { class: "p-field-label mb-2" }
const _hoisted_8 = {
  key: 1,
  class: "p-field"
}
const _hoisted_9 = {
  class: "p-field-label",
  for: "surname"
}
const _hoisted_10 = {
  key: 0,
  class: "text-primary d-block mt-1"
}
const _hoisted_11 = {
  key: 2,
  class: "p-field"
}
const _hoisted_12 = {
  class: "p-field-label",
  for: "name"
}
const _hoisted_13 = {
  key: 0,
  class: "text-primary d-block mt-1"
}
const _hoisted_14 = {
  key: 3,
  class: "p-field"
}
const _hoisted_15 = {
  class: "p-field-label",
  for: "companyName"
}
const _hoisted_16 = {
  key: 0,
  class: "text-primary d-block mt-1"
}
const _hoisted_17 = {
  key: 4,
  class: "p-field"
}
const _hoisted_18 = {
  class: "p-field-label",
  for: "additionalDescription"
}
const _hoisted_19 = {
  key: 0,
  class: "text-primary d-block mt-1"
}
const _hoisted_20 = {
  key: 5,
  class: "p-field"
}
const _hoisted_21 = { class: "col mb-3" }
const _hoisted_22 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_23 = {
  class: "p-field-label",
  for: "image"
}
const _hoisted_24 = { class: "bt-icon bt-icon--xs" }
const _hoisted_25 = { class: "ml-2" }
const _hoisted_26 = { class: "text-gray" }
const _hoisted_27 = {
  key: 0,
  class: "p-card m-2"
}
const _hoisted_28 = { class: "p-card-body" }
const _hoisted_29 = { class: "p-card-content d-flex justify-content-between align-items-center" }
const _hoisted_30 = { class: "bt-icon my-auto bt-icon--m" }
const _hoisted_31 = { class: "bt-icon bt-icon--m" }
const _hoisted_32 = { class: "card__head d-flex flex-column w-100" }
const _hoisted_33 = { class: "ml-3" }
const _hoisted_34 = { class: "m-0" }
const _hoisted_35 = { class: "p-field" }
const _hoisted_36 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_37 = {
  class: "p-field-label",
  for: "information"
}
const _hoisted_38 = { class: "bt-icon bt-icon--xs" }
const _hoisted_39 = { class: "ml-2" }
const _hoisted_40 = { class: "bt-icon bt-icon--xs" }
const _hoisted_41 = { class: "ml-2" }
const _hoisted_42 = {
  key: 0,
  class: "information-text"
}
const _hoisted_43 = { class: "p-field-label char-remain-count" }
const _hoisted_44 = {
  key: 1,
  class: "text-gray"
}
const _hoisted_45 = {
  key: 1,
  class: "my-3 d-flex"
}
const _hoisted_46 = { class: "px-2 warning-label" }
const _hoisted_47 = { class: "dialog-custom__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ListItemRadio = _resolveComponent("ListItemRadio")
  const _component_InputText = _resolveComponent("InputText")
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isVisible,
    "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => (_ctx.isVisible = $event)),
    modal: true,
    showHeader: false,
    closable: false,
    class: "dialog-custom dialog-edit-label"
  }, {
    default: _withCtx(() => [
      _createVNode("header", _hoisted_1, [
        _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.dialogTitle), 1)
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_ElScrollbar, { class: "dialog-scroll" }, {
            default: _withCtx(() => [
              (!_ctx.isBRFA)
                ? (_openBlock(), _createBlock("div", _hoisted_5, [
                    (!_ctx.isBRFA)
                      ? (_openBlock(), _createBlock("div", _hoisted_6, [
                          _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("AppResource.TypeUpper")), 1),
                          _createVNode(_component_ListItemRadio, {
                            modelValue: _ctx.isPrivate,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isPrivate = $event)),
                            inputId: "privateLabel",
                            name: "privateLabel",
                            value: true,
                            label: _ctx.$t('AppResource.Private')
                          }, null, 8, ["modelValue", "label"]),
                          _createVNode(_component_ListItemRadio, {
                            modelValue: _ctx.isPrivate,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isPrivate = $event)),
                            inputId: "privateLabel",
                            name: "privateLabel",
                            value: false,
                            label: _ctx.$t('AppResourceEP.Business'),
                            last: ""
                          }, null, 8, ["modelValue", "label"])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isPrivate)
                      ? (_openBlock(), _createBlock("div", _hoisted_8, [
                          _createVNode("label", _hoisted_9, _toDisplayString(`${_ctx.$t("AppResourceEP.Line")} 1 (Max ${_ctx.maxLineFieldLength} ${_ctx.$t("AppResourceEP.Characters")})`), 1),
                          _createVNode(_component_InputText, {
                            placeholder: _ctx.$t('AppResourceEP.InsertTheSurname'),
                            id: "surname",
                            type: "text",
                            class: "w-100",
                            modelValue: _ctx.surname,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.surname = $event)),
                            maxlength: _ctx.maxLineFieldLength
                          }, null, 8, ["placeholder", "modelValue", "maxlength"]),
                          (_ctx.surname.length > 10)
                            ? (_openBlock(), _createBlock("small", _hoisted_10, _toDisplayString(_ctx.$t("AppResourceEP.LabelMayNotBeFullyDisplayed")), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isPrivate)
                      ? (_openBlock(), _createBlock("div", _hoisted_11, [
                          _createVNode("label", _hoisted_12, _toDisplayString(`${_ctx.$t("AppResourceEP.Line")} 2 (Max ${_ctx.maxLineFieldLength} ${_ctx.$t("AppResourceEP.Characters")})`), 1),
                          _createVNode(_component_InputText, {
                            placeholder: _ctx.$t('AppResourceEP.InsertTheName'),
                            id: "name",
                            type: "text",
                            class: "w-100",
                            modelValue: _ctx.name,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.name = $event)),
                            maxlength: _ctx.maxLineFieldLength
                          }, null, 8, ["placeholder", "modelValue", "maxlength"]),
                          (_ctx.name.length > 10)
                            ? (_openBlock(), _createBlock("small", _hoisted_13, _toDisplayString(_ctx.$t("AppResourceEP.LabelMayNotBeFullyDisplayed")), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isPrivate)
                      ? (_openBlock(), _createBlock("div", _hoisted_14, [
                          _createVNode("label", _hoisted_15, _toDisplayString(`${_ctx.$t("AppResourceEP.CompanyName")} (Max ${_ctx.maxLineFieldLength} ${_ctx.$t("AppResourceEP.Characters")})`), 1),
                          _createVNode(_component_InputText, {
                            placeholder: _ctx.$t('AppResourceEP.InsertTheCompanyName'),
                            id: "companyName",
                            type: "text",
                            class: "w-100",
                            modelValue: _ctx.companyName,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.companyName = $event)),
                            maxlength: _ctx.maxLineFieldLength
                          }, null, 8, ["placeholder", "modelValue", "maxlength"]),
                          (_ctx.companyName.length > 10)
                            ? (_openBlock(), _createBlock("small", _hoisted_16, _toDisplayString(_ctx.$t("AppResourceEP.LabelMayNotBeFullyDisplayed")), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isPrivate)
                      ? (_openBlock(), _createBlock("div", _hoisted_17, [
                          _createVNode("label", _hoisted_18, _toDisplayString(`${_ctx.$t("AppResourceEP.AdditionalDescription")} (Max ${_ctx.maxAdditionalDescriptionLength} ${_ctx.$t("AppResourceEP.Characters")})`), 1),
                          _createVNode(_component_InputText, {
                            placeholder: _ctx.$t('AppResourceEP.InsertAdditionalDescription'),
                            id: "additionalDescription",
                            type: "text",
                            class: "w-100",
                            modelValue: _ctx.additionalDescription,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.additionalDescription = $event)),
                            maxlength: _ctx.maxAdditionalDescriptionLength
                          }, null, 8, ["placeholder", "modelValue", "maxlength"]),
                          (_ctx.additionalDescription.length > 16)
                            ? (_openBlock(), _createBlock("small", _hoisted_19, _toDisplayString(_ctx.$t("AppResourceEP.LabelMayNotBeFullyDisplayed")), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isPrivate)
                      ? (_openBlock(), _createBlock("div", _hoisted_20, [
                          _createVNode("div", _hoisted_21, [
                            _createVNode("div", _hoisted_22, [
                              _createVNode("label", _hoisted_23, _toDisplayString(_ctx.$t("AppResourceEP.ImageUpper")), 1),
                              _createVNode("input", {
                                type: "file",
                                id: "fileInput",
                                style: {"display":"none"},
                                onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onFileSelected && _ctx.onFileSelected(...args))),
                                accept: ".jpg, .jpeg"
                              }, null, 32),
                              _createVNode(_component_Button, {
                                class: "p-button-rounded p-button-outlined",
                                onClick: _ctx.triggerFilePicker,
                                disabled: _ctx.imageName != ''
                              }, {
                                default: _withCtx(() => [
                                  _createVNode("span", _hoisted_24, [
                                    _createVNode(_component_InlineSvgScoped, {
                                      src: 
                                                    require(`@/assets/images/icons/icon-plus-outline.svg`)
                                                ,
                                      "aria-label": "icon-grid"
                                    }, null, 8, ["src"])
                                  ]),
                                  _createVNode("span", _hoisted_25, _toDisplayString(_ctx.$t("AppResource.Add")), 1)
                                ]),
                                _: 1
                              }, 8, ["onClick", "disabled"])
                            ]),
                            _createVNode("small", _hoisted_26, _toDisplayString(_ctx.$t("AppResourceEP.NoImageAdded")), 1)
                          ]),
                          (_ctx.imageName != '')
                            ? (_openBlock(), _createBlock("div", _hoisted_27, [
                                _createVNode("div", _hoisted_28, [
                                  _createVNode("div", _hoisted_29, [
                                    _createVNode("span", _hoisted_30, [
                                      _createVNode("span", _hoisted_31, [
                                        _createVNode(_component_InlineSvgScoped, {
                                          src: 
                                                        require(`@/assets/images/icons/icon_parameters_and_settings_folder_2.svg`)
                                                    ,
                                          "aria-label": "icon-badge"
                                        }, null, 8, ["src"])
                                      ])
                                    ]),
                                    _createVNode("div", _hoisted_32, [
                                      _createVNode("div", _hoisted_33, [
                                        _createVNode("h4", _hoisted_34, _toDisplayString(_ctx.imageName), 1)
                                      ])
                                    ]),
                                    _createVNode(_component_Button, {
                                      class: "pl-0 mr-2 p-button-text",
                                      onClick: _ctx.removeImage
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Remove")), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_35, [
                _createVNode("div", _hoisted_36, [
                  _createVNode("label", _hoisted_37, _toDisplayString(_ctx.$t("AppResourceEP.Information")), 1),
                  _createVNode(_component_Button, {
                    class: "p-button-rounded p-button-outlined",
                    onClick: _cache[8] || (_cache[8] = 
                                    () =>
                                        (_ctx.isInformationVisible = !_ctx.isInformationVisible)
                                )
                  }, {
                    default: _withCtx(() => [
                      (_ctx.isInformationVisible)
                        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                            _createVNode("span", _hoisted_38, [
                              _createVNode(_component_InlineSvgScoped, {
                                src: 
                                                require(`@/assets/images/icons/icon-remove-outline.svg`)
                                            ,
                                "aria-label": "icon-grid"
                              }, null, 8, ["src"])
                            ]),
                            _createVNode("span", _hoisted_39, _toDisplayString(_ctx.$t("AppResource.Remove")), 1)
                          ], 64))
                        : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                            _createVNode("span", _hoisted_40, [
                              _createVNode(_component_InlineSvgScoped, {
                                src: 
                                                require(`@/assets/images/icons/icon-plus-outline.svg`)
                                            ,
                                "aria-label": "icon-grid"
                              }, null, 8, ["src"])
                            ]),
                            _createVNode("span", _hoisted_41, _toDisplayString(_ctx.$t("AppResource.Add")), 1)
                          ], 64))
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.isInformationVisible)
                  ? (_openBlock(), _createBlock("div", _hoisted_42, [
                      _createVNode(_component_Textarea, {
                        placeholder: _ctx.$t('AppResourceEP.InformationLabelPlaceholder'),
                        modelValue: _ctx.information,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.information = $event)),
                        id: "information",
                        class: "w-100 information-text__area",
                        maxlength: _ctx.informationMaxLength
                      }, null, 8, ["placeholder", "modelValue", "maxlength"]),
                      _createVNode("label", _hoisted_43, _toDisplayString(`${_ctx.remainingChars} ${_ctx.$t(
                                    "AppResourceEP.HomepageMessageRemaingChar"
                                )}`), 1)
                    ]))
                  : (_openBlock(), _createBlock("small", _hoisted_44, _toDisplayString(_ctx.$t("AppResourceEP.NoInformationAdded")), 1))
              ]),
              (!_ctx.isPrivate)
                ? (_openBlock(), _createBlock("div", _hoisted_45, [
                    _createVNode(_component_InlineSvgScoped, {
                      class: "svg-icon-alert",
                      src: 
                                require(`@/assets/images/icons/icon-alert-medium-outline.svg`)
                            ,
                      "aria-label": "icon-alert"
                    }, null, 8, ["src"]),
                    _createVNode("label", _hoisted_46, _toDisplayString(_ctx.$t("AppResourceEP.WarningBothImageAndInformation")), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("footer", _hoisted_47, [
        _createVNode(_component_Button, {
          class: "p-button-text mr-2",
          onClick: _ctx.handleHideDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Cancel")), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          class: "p-button-rounded p-button-raised p-button--m",
          onClick: _ctx.handleButtonSubmitAction,
          disabled: _ctx.saveButtonDisabled
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Save")), 1)
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}